import React, { FC } from "react";
import { toast } from "react-toastify";
import {
  useShareCampaignMutation,
  useShareDeliveryMutation,
  useShareVideoMutation,
} from "../../api/projectsApi";
import Form from "../../components/Form/Form";
import { ValidatorsE } from "../../components/Form/yupValidations";
import { P } from "../../components/Text/Text";
import { FormFieldT } from "../../models/models";
import { TOAST_DURATION_LONG } from "../../utils/helpers/constants";
import { useTranslate } from "../../utils/hooks/useTranslate";
import usePopup from "./../../utils/hooks/usePopup";

import styles from "./shareVideo.module.scss";

type ShareVideoPropTypes = {
  Id: number;
  type: "video" | "delivery" | "campaign";
};

const ShareVideo: FC<ShareVideoPropTypes> = ({ Id, type }) => {
  const [shareVideo] = useShareVideoMutation();
  const [shareDelivery] = useShareDeliveryMutation();
  const [shareCampaign] = useShareCampaignMutation();
  const { t } = useTranslate();
  const { removePopup } = usePopup();
  const fields: FormFieldT[] = [
    { label: "Email", validation: ValidatorsE.REQUIRED_STRING },
    {
      label: "Message",
      type: "textarea",
      orderIndex: 2,
      validation: ValidatorsE.REQUIRED_STRING,
    },
  ];

  const handleSubmit = async (data: any) => {
    const body = {
      Id,
      Email: data.email,
      ExtraText: data.message,
      ProjectType: "VideoAd",
    };
    try {
      let res;
      switch (type) {
        case "video": {
          res = await shareVideo({ Id, ...body });
          break;
        }
        case "delivery": {
          res = await shareDelivery({ Id, ...body });
          break;
        }
        case "campaign": {
          res = await shareCampaign({ Id, ...body });
          break;
        }
      }
      if (!res?.error?.data) {
        toast(t`Successfully sent`, {
          type: "success",
          autoClose: TOAST_DURATION_LONG,
        });
      }
      removePopup();
    } catch (e: any) {
      console.log(e);
    }
  };

  //Sharing the campaign will be accessible for users with the account in JumboMEDIA

  return (
    <>
      {type === "campaign" ? (
        <P>
          In this sharing action, the recipient will be sent a direct link to
          the page, but to be able to view the page, he must be a registered
          user in the system.
        </P>
      ) : type === "delivery" ? (
        <P>
          Please note that while sharing this page, your recipient will have
          access as a guest user to view the broadcasts and all campaign details
        </P>
      ) : null}
      <Form
        fields={fields}
        formID="share-video"
        onSubmit={handleSubmit}
        columns={1}
        elements={
          <div style={{ order: 1 }}>
            <P className={styles.hint}>Add more addresses with commas.</P>
          </div>
        }
      />
    </>
  );
};

export default ShareVideo;
